<mat-card>
  <mat-card-header>
    <mat-card-title>
      {{ guardian_info?.nombre }}
    </mat-card-title>
  </mat-card-header>
</mat-card>
<br />
<mat-card>
  <mat-grid-list cols="10" rowHeight="3:3">
    <mat-grid-tile [colspan]="6" [style.background]="'#FFF'">
      <div class="p-l-10">
        <p>
          <b>
            Para descubrir lo que nos trae el primer chaqru altoandino de la temporada 2022, por favor complete el
          siguiente formato: <a href="http://bit.ly/Huachhua">http://bit.ly/Huachhua</a>
          </b>
        </p>
      </div>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="4" [style.background]="'#FFF'">
      <p style="text-align: right;">
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSc9ipBqU3EiBfDlATKmvzqb_UdnM8H9VH40FxUAot10xkXWYg/closedform"
          mat-raised-button color="primary">Comercio Electrónico</a>
      </p>
    </mat-grid-tile>
  </mat-grid-list>

  <mat-card-content>
    <mat-grid-list cols="6" rowHeight="1:1" gutterSize="10px">
      <mat-grid-tile [style.background]="'#DDBDF1'" colspan="2" rowspan="2">
        <img src="{{ guardian_info?.image_src }}" style="object-fit: contain; background-size: cover" width="100%" />
      </mat-grid-tile>
      <mat-grid-tile [style.background]="'#F2F4F4'" rowspan="2">
        <img src="{{ guardian_info?.qr_src }}" style="object-fit: contain; background-size: cover" width="100%" />
      </mat-grid-tile>

      <mat-grid-tile [style.background]="'#F2F4F4'">
        <h3>{{ guardian_info?.sexo }}</h3>
      </mat-grid-tile>
      <mat-grid-tile [style.background]="'#F2F4F4'">
        <h2>{{ guardian_info?.edad }} AÑOS</h2>
      </mat-grid-tile>
      <mat-grid-tile [style.background]="'#F2F4F4'" style="text-align: center">
        <h3>{{ guardian_info?.estado }} {{ guardian_info?.hijos }} hijos</h3>
      </mat-grid-tile>
      <mat-grid-tile [style.background]="'#F2F4F4'">
        <h4>{{ guardian_info?.esposa }}</h4>
      </mat-grid-tile>

      <mat-grid-tile [style.background]="'#F2F4F4'">
        <h3>{{ guardian_info?.educacion }}</h3>
      </mat-grid-tile>

      <mat-grid-tile [style.background]="'#F2F4F4'">
        <h4>Variedades: {{ guardian_info?.variedades }}</h4>
      </mat-grid-tile>
    </mat-grid-list>
  </mat-card-content>
</mat-card>
<br />
<mat-card>
  <mat-card-header> </mat-card-header>
  <mat-card-content>
    <mat-grid-list cols="5" rowHeight="2:5" gutterSize="10px">
      <mat-grid-tile [style.background]="'#F2F4F4'" colspan="3">
        <div style="text-align: center; padding: 10em">
          <label style="font-size: 1.5em">
            <b>Comunidad de {{ guardian_info?.comunidad }}</b> - Distrinto de
            {{ guardian_info?.distrito }}, Provincia de
            {{ guardian_info?.provincia }}, Region de
            {{ guardian_info?.region }}, {{ guardian_info?.pais }}.
            {{ guardian_info?.poblado }}
          </label>
        </div>
      </mat-grid-tile>
      <mat-grid-tile [style.background]="'#F2F4F4'" colspan="2" rowspan="2">
        <div fxLayout="column" fxLayoutAlign="center center">
          <h2>VARIEDADES</h2>
          <h3 *ngFor="let tile of guardian_info?.variedad; let i = index">
            {{ i + 1 }}.{{ tile }}
          </h3>
        </div>
      </mat-grid-tile>
      <mat-grid-tile [style.background]="'#F2F4F4'" colspan="3">
        <div class="p-30" style="text-align: center">
          <h1>
            {{ guardian_info?.detalles }}<mat-icon>format_quote</mat-icon>
          </h1>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </mat-card-content>
</mat-card>